import LegalLayout, { H2, P, PH } from "../LegalLayout";

export default function Widerruf() {
  return (
    <LegalLayout title="Widerrufsbelehrung">
      <H2>Widerrufsrecht</H2>
      <P>
        Verbraucher haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.
      </P>
      <P>
        Die Frist beginnt mit dem Tag, an dem du oder ein von dir benannter Dritter (der nicht der Beförderer ist) die
        Waren in Besitz genommen hat.
      </P>
      <P>
        Um dein Widerrufsrecht auszuüben, informiere uns bitte mittels einer eindeutigen Erklärung über deinen Entschluss,
        diesen Vertrag zu widerrufen. Dafür kannst du unser{" "}
        <a href="/widerrufsformular" className="text-gold underline underline-offset-4">
          elektronisches Widerrufsformular
        </a>{" "}
        verwenden oder uns kontaktieren:
      </P>
      <PH>
        [Vor- und Nachname des Unternehmens], [Straße und Hausnummer], [PLZ und Ort], E-Mail: support@mazaro.de — hier
        vollständige Widerrufs-Kontaktdaten eintragen.
      </PH>

      <H2>Folgen des Widerrufs</H2>
      <P>
        Wenn du diesen Vertrag widerrufst, erstatten wir dir alle Zahlungen, die wir von dir erhalten haben —
        einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, wenn du eine andere Lieferart als die von
        uns angebotene günstigste Standardlieferung gewählt hast) — unverzüglich und spätestens vierzehn Tage ab dem Tag,
        an dem die Mitteilung über deinen Widerruf bei uns eingegangen ist.
      </P>
      <P>
        Für die Rückzahlung verwenden wir dasselbe Zahlungsmittel, das du bei der ursprünglichen Transaktion genutzt
        hast; es werden dir keinerlei Gebühren wegen der Rückzahlung berechnet.
      </P>

      <H2>Rücksendekosten und -bedingungen</H2>
      <P>
        Du musst für einen etwaigen Wertverlust der Waren nur aufkommen, wenn dieser Wertverlust auf einen zur Prüfung
        der Beschaffenheit, Eigenschaften und Funktionsweise der Waren nicht notwendigen Umgang zurückzuführen ist.
      </P>
      <PH>
        Rücksendekosten: Entscheide dich verbindlich für eine Variante und trage sie hier ein — [Wir tragen die Kosten
        der Rücksendung] oder [Du trägst die unmittelbaren Kosten der Rücksendung der Waren].
      </PH>

      <H2>Ausschlüsse</H2>
      <P>
        Das Widerrufsrecht erlischt bei versiegelten Waren, die aus Gründen des Gesundheitsschutzes oder der Hygiene
        nicht zur Rückgabe geeignet sind, wenn ihre Versiegelung nach der Lieferung entfernt wurde (relevant z.B. für
        Bandagen). Bei Waren, die nach Kundenspezifikation angefertigt werden, besteht kein Widerrufsrecht.
      </P>
    </LegalLayout>
  );
}
